var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStocks10(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 595.28 841.89",
    style: {
      enableBackground: "new 0 0 595.28 841.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#64AB45;}\r\n\t.st1{fill:#71BF44;}\r\n\t.st2{fill:#5FA544;}\r\n\t.st3{fill:#C3D82E;}\r\n\t.st4{fill:#FFFFFF;}\r\n\t.st5{fill:#616264;}\r\n\t.st6{font-family:'FuturaBT-BoldItalic';}\r\n\t.st7{font-size:35.4615px;}\r\n\t.st8{font-size:55.632px;}\r\n\t.st9{letter-spacing:-7.22;}\r\n\t.st10{fill:#579240;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "212.52,493.14 212.48,485.65 244.59,485.66 244.93,419.96 260.64,410.82 260.33,493.15  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "272.66,492.97 272.91,414.16 260.82,410.58 260.64,400.32 283.62,389.07 283.63,492.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "296.48,382.51 283.62,388.83 283.18,368.72 313.24,349.92 314.45,493.04 297.34,493.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "316.99,353.48 321.93,357.65 323,493.12 318.13,493.09  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "324.44,358.72 326.32,493.12 330.06,493.12 328.76,361.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "331.64,363.3 333.52,493.12 338.99,493.12 336.78,366.36  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M316.8,430.21c2.32,6.3,6.74-2.03,13.29-4.94c2.38-1.06,5.21-0.67,7.13,1.1c2.22,2.06,5.85,6.72,10.46,3.84 c0,0,3.38,9.1,13.73,7.04c-0.8,0.03-9.59,0.24-11.82-9.4c0,0,0.22-9.46,13.79-7.13c13.57,2.34,17.81,2.55,21.63-5.09 c0,0,1.06,10.39-19.51,9.97c0,0-9.81-1.06-6.71,7.42c0,0,0.56-4,3.1-4.33c0,0,5.74,4.55,13.16,5.82c0,0,1.71,1.01,0,2.73 l14.21,4.27c0,0,0.21,11.45-9.97,12.3c-10.18,0.85-24.58,8.13-27.15,17.4c0,0,10.44,9.89,19.98,9.03c0,0-47.09,8.6-61.03-39.9 c0,0-10.16-37.95,26.4-56.56C335.17,385.06,306.29,401.69,316.8,430.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M416.12,428.31c0.52,29.68-23.12,54.16-52.8,54.68c-26.18,0.45-48.32-17.88-53.52-42.59 c5.14,22.6,25.55,39.29,49.65,38.87c27.63-0.48,49.63-23.27,49.15-50.89c-0.48-27.63-23.27-49.63-50.89-49.15 c-7.08,0.12-13.79,1.71-19.84,4.47c-0.02,0.01-0.04,0.02-0.06,0.03c-13.94,6.37-24.41,18.95-27.95,34.15 c5.14-23.85,26.15-41.92,51.6-42.36C391.13,375,415.6,398.64,416.12,428.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M413.11,428.34c0.5,28.84-22.47,52.62-51.3,53.13c-25.44,0.44-46.95-17.38-52.01-41.38 c4.99,21.96,24.83,38.18,48.25,37.77c26.84-0.47,48.23-22.61,47.76-49.45c-0.47-26.84-22.61-48.23-49.45-47.76 c-6.88,0.12-13.4,1.67-19.28,4.35c-0.02,0.01-0.04,0.02-0.06,0.03c-13.55,6.19-23.72,18.41-27.16,33.18 c4.99-23.18,25.41-40.73,50.14-41.16C388.82,376.53,412.61,399.5,413.11,428.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M379.29,453.81c-10.18,0.85-24.58,8.13-27.15,17.4c0,0,9.25,10.11,18.79,9.25c0,0-45.9,8.37-59.84-40.12 c0,0-10.16-37.95,26.4-56.56c-2.81,0.85-28.51,19.23-20.7,46.43c1.85,6.45,6.74-2.03,13.29-4.94c2.38-1.06,5.21-0.67,7.13,1.1 c2.22,2.06,5.85,6.72,10.46,3.84c0,0,3.38,9.1,13.73,7.04c-0.8,0.03-9.59,0.24-11.82-9.4c0,0,0.22-9.46,13.79-7.13 c13.57,2.34,17.81,2.55,21.63-5.09c0,0,1.06,10.39-19.51,9.97c0,0-9.81-1.06-6.71,7.42c0,0,0.56-4,3.1-4.33 c0,0,5.74,4.55,13.16,5.82c0,0,1.71,1.01,0,2.73l14.21,4.27C389.26,441.51,389.47,452.96,379.29,453.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M379.09,455.33c-10.26,0.83-24.76,7.99-27.34,17.09c0,0,9.53,10.57,19.18,8.03c0,0-48.56,11.32-61.95-38.86 c0,0-10.95-36.15,25.12-56.06c-2.34,1.26-27.25,18.11-17.95,46.61c2.05,6.29,6.79-1.99,13.39-4.85c2.4-1.04,5.25-0.66,7.18,1.08 c2.24,2.02,5.9,6.6,10.53,3.77c0,0,3.4,8.94,13.82,6.92c-0.8,0.03-9.66,0.23-11.9-9.24c0,0,0.22-9.29,13.89-7 c13.67,2.3,17.94,2.5,21.78-5c0,0,1.07,10.21-19.65,9.8c0,0-9.88-1.04-6.76,7.29c0,0,0.57-3.93,3.13-4.26 c0,0,5.78,4.47,13.25,5.72c0,0,1.72,0.99,0,2.68l14.31,4.19C389.13,443.25,389.34,454.5,379.09,455.33z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "356.56,369.24 356.88,373.82 371.72,359.24 351.82,366.53 356.12,368.72 368.31,361.39  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M367.08,436.11l7.17,2.28C374.25,438.39,368.95,441.81,367.08,436.11z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "212.5,490.85 212.9,440.56 229.94,429.17 229.62,490.96  "
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.97 -1.474398e-03 1.519998e-03 1 212.4751 524.2487)",
    className: "st5 st6 st7"
  }, "STOCKS"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.97 4.345600e-03 -4.480000e-03 1 345.7306 524.6101)",
    className: "st3 st6 st8 st9"
  }, "10"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.97 4.345600e-03 -4.480000e-03 1 343.455 524.223)",
    className: "st10 st6 st8 st9"
  }, "10"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "335.57,382.45 363.38,364.99 335.7,382.66  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M335.64,382.56c0.71-0.43,9.19-6.6,32.68-21.17c0,0-22.47,13.62-31.99,20.15 c-9.51,6.53-30.71,19.47-29.12,51.97c1.69,34.44,29.64,44.79,31.79,45.7c2.14,0.91,14.92,4.77,26.7,3.65c0,0-36.2,3.37-51.09-29.41 C300.16,421.61,316.98,393.86,335.64,382.56z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocks10);
export default __webpack_public_path__ + "static/media/Stocks10.e0b82dcba93e26ada818a7feba055b58.svg";
export { ForwardRef as ReactComponent };